import React from 'react';
import createSvgIcon from '../../../utils/createSvgIcon';

export default createSvgIcon(
  [<g key="0"><path fill="currentColor" d="M8 5v14l11-7z" /></g>,<defs key="1"></defs>,]
, 'CameraVideoPlayFilledx');
